module.exports = __webpack_public_path__ + "1ec2f40a.png";